import { render, staticRenderFns } from "./NguoiDungTcqlttForm.vue?vue&type=template&id=3d95bb2e&"
import script from "./NguoiDungTcqlttForm.vue?vue&type=script&lang=js&"
export * from "./NguoiDungTcqlttForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports